import { tv } from 'tailwind-variants';

import {
  Button,
  InputWrapper,
  Form,
  MarkdownPreview,
} from '@frontendmentorio/design-system-v2';

const style = tv({
  base: [
    'bg-gray-100',
    'flex',
    'flex-col',
    'gap-4',
    'p-4',
    'rounded-xl',
    'w-full',
  ],
});

export default function CommentForm({
  ariaLabel,
  buttonText,
  className,
  defaultValue,
  disabled,
  onSubmit: handleSubmit,
}) {
  return (
    <Form className={style({ class: className })} onSubmit={handleSubmit}>
      <InputWrapper
        ariaLabel={ariaLabel}
        defaultValue={defaultValue}
        input={MarkdownPreview}
        name="content"
        validations={{ required: true }}
      />

      <Button className="self-end" disabled={disabled} isWide level="primary">
        {buttonText}
      </Button>
    </Form>
  );
}
